import { InfoIcon, LayoutGridIcon, ZapIcon } from "lucide-react";
import checkOutIcon from "@/assets/icons/CheckOutIcon.svg";
import checkOutActiveIcon from "@/assets/icons/CheckOutActiveIcon.svg";
import checkInIcon from "@/assets/icons/CheckInIcon.svg";
import checkInActiveIcon from "@/assets/icons/CheckInActiveIcon.svg";
import { Link } from "react-router-dom";
import { MessageDialog } from "./MessageDialog";
import { APP_VERSION } from "@/constants";

type BottomNavProps = {
  active: number;
};

export const BottomNav = ({ active }: BottomNavProps) => {
  return (
    <div className="fixed bottom-0 w-full bg-primary-foreground h-20 rounded-t-xl shadow-[0px_-6px_16px_rgba(62,190,200,0.11)] flex justify-around items-center">
      <Link to="/home" className="flex flex-col items-center">
        <LayoutGridIcon
          className={active === 1 ? "text-primary h-7 w-7" : "h-7 w-7"}
        />
      </Link>
      <Link to="/check-in" className="flex flex-col items-center">
        <img
          src={active === 2 ? checkInActiveIcon : checkInIcon}
          alt="Check In"
          className="h-7 w-7"
        />
      </Link>
      <Link to="/check-out" className="flex flex-col items-center">
        <img
          src={active === 3 ? checkOutActiveIcon : checkOutIcon}
          alt="Check Out"
          className="h-10 w-10"
        />
      </Link>
      {/* <MessageDialog
        title="Notice"
        message="Please scan the QR code using your Google scanner and continue."
      >
        <div className="flex flex-col items-center">
          <ZapIcon
            className={active === 4 ? "text-primary h-7 w-7" : "h-7 w-7"}
          />
        </div>
      </MessageDialog> */}
      <MessageDialog title="" message={`Everest EV Fleet App v${APP_VERSION}`}>
        <div className="flex flex-col items-center">
          <InfoIcon
            className={active === 5 ? "text-primary h-7 w-7" : "h-7 w-7"}
          />
        </div>
      </MessageDialog>
    </div>
  );
};
